import { Loader2 } from 'lucide-react';
import { SOCIAL_CONNECTION_PRICE_LABEL } from '../lib/socialConnectionSeats';

interface SocialConnectionPurchaseModalProps {
  open: boolean;
  platformLabel: string;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Confirm before charging one social connection seat (team-seat style). */
export default function SocialConnectionPurchaseModal({
  open,
  platformLabel,
  busy = false,
  onConfirm,
  onCancel,
}: SocialConnectionPurchaseModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100200] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div
        className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden"
        role="dialog"
        aria-modal="true"
        aria-labelledby="social-seat-title"
      >
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 id="social-seat-title" className="text-lg font-semibold text-gray-900">
            Connect {platformLabel}
          </h3>
        </div>
        <div className="p-6">
          <p className="text-sm text-gray-600 leading-relaxed">
            Media connections are billed as a single add-on at{' '}
            <strong className="text-gray-900">{SOCIAL_CONNECTION_PRICE_LABEL}</strong> on your Nexus
            subscription — one price covers all your social profiles (Facebook, Instagram, and Google
            Business). You can disconnect anytime; billing updates on your next invoice (prorated).
          </p>
          <div className="mt-5 flex gap-3">
            <button
              type="button"
              onClick={onCancel}
              disabled={busy}
              className="flex-1 px-4 py-2.5 rounded-xl border border-gray-200 text-sm font-semibold text-gray-700 hover:bg-gray-50 disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={busy}
              className="flex-1 px-4 py-2.5 rounded-xl bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700 disabled:opacity-50 inline-flex items-center justify-center gap-2"
            >
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
              {busy ? 'Processing…' : `Continue · ${SOCIAL_CONNECTION_PRICE_LABEL}`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
